





















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Feedback } from '@/types/Feedback.type'
import moment from 'moment'
import { Member } from '@/types/Member.type'
import { namespace } from 'vuex-class'
import FeedbackForm from '@/utils/FeedbackForm'
import API from '@/services/API'
import SuccessAlert from '@/components/feedback/SuccessAlert.vue'
import ProfileMemberHeader from '@/components/feedback/FeedbackRelationshipModal/ProfileMemberHeader.vue'
import RelationHeader from '@/components/feedback/FeedbackRelationshipModal/RelationHeader.vue'
import FormPart from '@/components/feedback/form-parts/FormPart.vue'
import Loader from '@/components/Loader.vue'
import BusinessConnectionHeader from './FeedbackRelationshipModal/BusinessConnectionHeader.vue'

const User = namespace('user')
@Component({
    components: { Loader, FormPart, RelationHeader, ProfileMemberHeader, SuccessAlert, BusinessConnectionHeader },
})
export default class FeedbackRelationshipModal extends Vue {
    @Prop({ type: Object, required: true }) feedback!: Feedback
    @Prop({ type: Number, default: null }) score!: number | null

    @User.State me!: Member

    showModal = true
    globalRate = null
    loading = false
    answers = null
    error = null
    form: FeedbackForm | null = null
    showMemberPicture = true
    pingSuccess = false

    @Watch('showModal') onShowModalUpdated() {
        this.handleBodyScroll()
    }

    get memberId() {
        return this.me && this.me.idff
    }

    get isFinished() {
        return this.feedback && this.feedback.status && this.feedback.status === 'done'
    }

    get modalConfirmation() {
        if (this.form && this.form.questions && this.form.questions.length) {
            const modal = this.form.questions[0]

            if (modal.type === 'modal_confirmation') {
                return {
                    title: modal.subject,
                    message: modal.options.message,
                    options: modal?.options,
                }
            }
        }

        return null
    }
    get modalContact() {
        if (this.form && this.form.questions && this.form.questions.length) {
            const modal = this.form.questions[0]

            if (modal.type === 'modal_relationship_contact') {
                return modal
            }
        }

        return null
    }
    get isFirstStep() {
        if (this.form && this.form.formStep) {
            return this.form.formStep === 1
        } else {
            return true
        }
    }
    get memberToShow() {
        if (this.memberId && this.feedback && this.feedback.relationship_establishment) {
            return this.memberId === this.feedback.relationship_establishment.first_member.idff
                ? this.feedback.relationship_establishment.second_member
                : this.feedback.relationship_establishment.first_member
        }

        return null
    }
    get dateConnection() {
        if (!this.dateConnectionPure) {
            return null
        }

        return this.$trans('feedback.date', 'front_feedback', { date: this.dateConnectionPure })
    }

    get dateConnectionPure() {
        if (!this.feedback?.relationship_establishment) {
            return null
        }

        moment.locale(this.$trans('feedback.locale', 'front_feedback'))
        const date = moment(
            this.feedback.relationship_establishment.business_connection_rdv_date ||
                this.feedback.relationship_establishment.scheduled_at ||
                this.feedback.relationship_establishment.created_at
        ).format(this.$trans('feedback.date_format', 'front_feedback'))

        return date
    }

    get members() {
        if (!this.feedback?.relationship_establishment) {
            return []
        }
        return [
            this.feedback.relationship_establishment.second_member,
            this.feedback.relationship_establishment.first_member,
        ]
    }

    mounted() {
        this.handleBodyScroll()
        this.handleFeedback(this.feedback)

        if (this.score) {
            const element = this.feedback.form.form_elements.find(formEl =>
                formEl.type === 'global-rate' ? formEl : null
            )

            if (element) {
                this.form?.setAnswer(element.id, this.score)
            }
        }
    }

    handleScroll(e: any) {
        if (e.target.scrollTop >= 25) {
            this.showMemberPicture = false
        } else {
            this.showMemberPicture = true
        }
    }
    handleBodyScroll() {
        if (this.showModal) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'visible'
        }
    }
    handleFeedback(feedback: Feedback) {
        if (feedback) {
            this.feedback = feedback
            this.form = new FeedbackForm(feedback.form)

            if (!this.form.form.form_elements.length) {
                this.showModal = false
            }
        }

        this.loading = false
    }
    onClick(formEl: HTMLFormElement) {
        this.form?.setAnswer(formEl.id, true)
        this.sendAnswers()
    }
    onAnswer(answer: any) {
        this.form?.setAnswer(answer.id, answer.answer)
    }
    sendAnswers() {
        this.loading = true
        this.globalRate = this.form?.globalRateValue

        if (!this.feedback) {
            throw new Error('No feedback')
        }

        API.postFeedbackAnswers(this.feedback.id, this.form?.feedbackAnswersObject)
            .then(data => {
                this.handleFeedback(data)
            })
            .catch(err => {
                this.error = err
                this.showModal = false
            })
    }
    goBack() {
        this.loading = true

        API.getFeedbackBack(this.feedback.id, this.form?.form.form_step)
            .then(data => {
                this.handleFeedback(data)
            })
            .catch(err => {
                this.error = err
                this.showModal = false
            })
    }
    pingAdmin() {
        if (!this.feedback) {
            throw new Error('No feedback')
        }

        this.loading = true

        API.feedbackPingAdmin(this.feedback.id)
            .then(() => {
                this.loading = false
                this.pingSuccess = true
            })
            .catch(error => {
                this.error = error
                this.showModal = false
            })
    }
    dismiss() {
        this.showModal = false
    }
    formatDateFr(date: string) {
        const d = new Date(date)

        const day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
        const month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
        const year = d.getFullYear()

        return day + '/' + month + '/' + year
    }
    getCookie(cname: string) {
        const name = cname + '='
        const decodedCookie = decodeURIComponent(document.cookie)
        const ca = decodedCookie.split(';')

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i]
            while (c.charAt(0) == ' ') {
                c = c.substring(1)
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length)
            }
        }
        return ''
    }
    onContact() {
        if (!this.memberToShow || !this.feedback.relationship_establishment) {
            return null
        }

        window.location.href = `/messaging/open_channel/${this.memberToShow.idff}/${this.feedback.relationship_establishment.sendbird_channel_url}`
    }
    onSeeProfile() {
        if (!this.memberToShow) {
            return null
        }

        this.showModal = false
        window.location.href = `/member/${this.memberToShow.idff}`
    }
}
